import { useEffect, useState } from "react";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNotificationContext } from "contexts/NotificationContext";
import { fetchTripEstimationByIdApi } from "api/trips";
import { ITripDetailResponse } from "models/trips";
import pickupIcon from "assets/images/pickup.png";
import dropOffIcon from "assets/images/drop-off.png";

// Create static Leaflet icons
const PickupMapIcon = new L.Icon({
  iconUrl: pickupIcon,
  iconSize: [40, 30],
  iconAnchor: [20, 30],
});

const DropOffMapIcon = new L.Icon({
  iconUrl: dropOffIcon,
  iconSize: [40, 30],
  iconAnchor: [20, 30],
});

export default function TripEstimationRoute() {
  const id: string = useParams().id!;
  const [data, setData] = useState<ITripDetailResponse>();
  const [currentLocation, setCurrentLocation] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 13.496494229233356,
    lng: 39.47494624044569,
  });
  const { showError } = useNotificationContext();

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line

  const fetchData = async () => {
    const { data, error } = await fetchTripEstimationByIdApi(id);
    if (data?.data) {
      setData(data.data);
      if (data.data.estimation_location.length > 0)
        setCurrentLocation({
          lat: data.data.estimation_location[0].latitude,
          lng: data.data.estimation_location[0].longitude,
        });
    } else showError(error!.message);
  };

  const polylinePositions =
    data?.estimation_location.map(
      (value) => [value.latitude, value.longitude] as [number, number]
    ) ?? [];

  return (
    <>
      {data ? (
        <MapContainer
          center={[currentLocation.lat, currentLocation.lng]}
          zoom={16}
          style={{ width: "100%", height: "100vh", zIndex: 0 }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {data.estimation_location.length > 0 && (
            <Marker
              icon={PickupMapIcon}
              position={[
                data.estimation_location[0].latitude,
                data.estimation_location[0].longitude,
              ]}
            />
          )}
          {data.estimation_location.length > 1 && (
            <Marker
              icon={DropOffMapIcon}
              position={[
                data.estimation_location[
                  data.estimation_location.length - 1
                ].latitude,
                data.estimation_location[
                  data.estimation_location.length - 1
                ].longitude,
              ]}
            />
          )}

          <Polyline
            positions={polylinePositions}
            color="#581845"
            weight={4}
            opacity={1.0}
          />
        </MapContainer>
      ) : (
        <div className="w-full h-full grow flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
    </>
  );
}
